import { Button, Dialog, Stack, Typography } from "@mui/material";
import { useIntl } from "react-intl";
import theme from "../../config/theme";
import { OrderItemsWithQuantity } from "../../my-lemonade-library/model/Order";

interface QuantityModalProps {
    open: boolean;
    unavailableProducts: OrderItemsWithQuantity[];
    onClose: () => void;
}

export const QuantityModal = (props: QuantityModalProps) => {
    const {
        open,
        unavailableProducts,
        onClose
    } = props;

    const intl = useIntl();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            onBlur={onClose}
            PaperProps={{
                style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: theme.spacing(2),
                    margin: theme.spacing(1),
                    textAlign: 'center',
                    minWidth: '30vw'
                }
            }}
        >
            <Stack direction={'column'} alignItems={'center'} gap={2} width={1}>
                <Typography variant="h3" style={{ fontWeight: "bold" }}>
                    {intl.formatMessage({ id: "quantityModal.title" })}
                </Typography>
                <Stack direction={'column'} gap={2}>
                    <Typography variant="subtitle2">
                        {intl.formatMessage({ id: "quantityModal.subtitle" })}
                    </Typography>

                    {unavailableProducts.map((up) => (
                        <Stack
                            direction={'column'}
                            gap={1}
                            sx={{
                                border: `1px solid ${theme.palette.grey[300]}`,
                                backgroundColor: theme.palette.grey[200],
                                padding: 1,
                                borderRadius: 2,
                            }}
                        >
                            <Typography variant="subtitle2" fontWeight={'bold'}>
                                {up.product_name} :
                            </Typography>
                            <Typography variant="body2">
                                {intl.formatMessage({ id: "quantityModal.asked" })} {up.quantity}
                            </Typography>
                            <Typography variant="body2" color={theme.palette.error.light}>
                                {intl.formatMessage({ id: "quantityModal.remaining" })} {up.remaining_qty}
                            </Typography>
                        </Stack>
                    ))}
                </Stack>

                <Button
                    data-test="payment.tips.button.add_tips"
                    style={{
                        flex: 1,
                        width: "80%",
                        textTransform: "none",
                        marginTop: 10
                    }}
                    onClick={() => onClose()}
                    variant='contained'
                    color='primary'
                >
                    {intl.formatMessage({ id: "common.update" })}
                </Button>
            </Stack>
        </Dialog>
    )
}